<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ToggleAuctionMatches" });
import { InputToggle } from "../../../../selects/index.js";
export let isChecked = false;
export let isDisabled = false;
export let isRequired = false;
</script>

<InputToggle
    bind:isChecked
    name = 'auctions.showOnlyMatches'
    label = 'Show only deals that match your preferences.'
    color = 'quaternary'
    size = 'lg'
    { isDisabled }
    { isRequired }
/>